// Libraries
import React from 'react';
import { useNavigate } from 'react-router-dom';

// Local
import { AppBar, Toolbar, Typography, Link, Stack } from '@mui/material';
import DarkModeToggle from './DarkModeToggle';

const Menu = () => {
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      sx={{
        width: '100%',
        color: 'text.primary',
        bgcolor: 'transparent',
        alignItems: 'space-between',
        boxShadow: 'none',
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
      }}
      >
        <Stack
          direction={'row'}
          sx={{
            display: 'flex-start',
            cursor: 'pointer',
          }}
          spacing={1}
          alignItems={'center'}
          justifyContent={'flex-start'}
          onClick={() => navigate('/')}
        >
          <img
            src="/logo.png"
            alt="Endoc logo"
            style={{
              height: '40px',
              width: '35px',
            }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 'bold',
            }}
          >
            Endoc
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={5}
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Link 
            variant='plain'
            onClick={() => navigate('/login')}   
            underline='none'
          >
            <Typography
              variant="body1"
              sx={{
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              Log in
            </Typography>
          </Link>
          <Link 
            onClick={() => navigate('/team')}
            underline='none'
          >
            <Typography
              variant="body1"
              sx={{
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              Team
            </Typography>
          </Link>
          <DarkModeToggle />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Menu;
